var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    _vm.$style.textInput,
    _vm.isFilled && _vm.$style.filled,
    _vm.error && _vm.$style.error,
    _vm.disabled && _vm.$style.disabled
  ]},[_c('input',{directives:[{name:"cleave",rawName:"v-cleave",value:({
      phone: true,
      phoneRegionCode: 'tw',
      onValueChanged: _vm.onValueChanged,
    }),expression:"{\n      phone: true,\n      phoneRegionCode: 'tw',\n      onValueChanged,\n    }"}],class:_vm.$style.input,attrs:{"id":_vm.id,"type":"text","inputmode":"tel","disabled":_vm.disabled,"placeholder":_vm.placeholder},domProps:{"value":_vm.value}}),_c('transition',{attrs:{"name":"slide-fade"}},[(_vm.error)?_c('Error',[_vm._v(" "+_vm._s(_vm.error)+" ")]):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }